<template>
  <div>
    <div style="height: 110px;"></div>
    <nav class="mb20 fixed w-full shadow-lg py-6 px-4 xl:px-8 xl:py-0 left-0 right-0 z-[30] top-0 rounded-bl-3xl rounded-br-3xl " id="nav">
                <div class="xl:flex flex-wrap flex-nowrap flex-row justify-between hidden">
            <div class="w-[5rem] xl:w-16 mx-auto xl:mx-0 flex items-center py-7">
                <a href="/">
                    <img src="@/components/Header/images/br-logo.png" class="w-full" alt="Baskin Robbins" />
                </a>
            </div>
            <div class="flex items-center">
                

            <ul class="flex flex-col space-y-5 xl:flex-row xl:space-y-0 items-start xl:h-full " >
                <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase " 
                href="/"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true; hoverActive = 0;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Home
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                    </li>
            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href=""
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true; hoverActive = 1;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                What&#039;s New
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                            <div
                    @mouseover="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = true ; isActive = true;
                    }"
                    @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = false ; isActive = false;
                    }"
                    :class="{ 'active': isActive && hoverActive == 1 }"
                    class="dropdown-list ml-4 xl:bg-white xl:ml-0 xl:top-[92px] relative xl:absolute rounded-bl-md rounded-br-md border-gray-700 flex flex-col">
                                                                <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/whats-new/happy-value-pack">Happy Value Pack</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/whats-new/variety-pack">Variety Pack</a>
                                    </div>
                    </li>

                <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase " 
                href="https://live.prodapp.baskinrobbins.my/oms/#/chooseLocation/index"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true; hoverActive = 2;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Order Now
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                    </li>
                    <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase " 
                href="https://live.prodapp.baskinrobbins.my/oms/#/center/orderList"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true; hoverActive = 3;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                My Order
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                    </li>
            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href=""
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true; hoverActive = 4;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Products
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                            <div
                    @mouseover="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = true ; isActive = true;
                    }"
                    @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = false ; isActive = false;
                    }"
                    :class="{ 'active': isActive && hoverActive == 4 }"
                    class="dropdown-list ml-4 xl:bg-white xl:ml-0 xl:top-[92px] relative xl:absolute rounded-bl-md rounded-br-md border-gray-700 flex flex-col">
                                                                <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/icecreams">Ice Cream</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/cakes">Cakes</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/mixnshakes">Beverages</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/party-kits">Party Kits</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/merchandise">Merchandise</a>
                                    </div>
                    </li>
            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href="https://www.baskinrobbins.com.my/club-31-exclusive"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true; hoverActive = 5;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false; 
                }"
            >
                                Club 31 Exclusive
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                    </li>
            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href=""
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true; hoverActive = 6;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Contact Us
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                            <div
                    @mouseover="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = true ; isActive = true;
                    }"
                    @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = false ; isActive = false;
                    }"
                    :class="{ 'active': isActive && hoverActive == 6 }"
                    class="dropdown-list ml-4 xl:bg-white xl:ml-0 xl:top-[92px] relative xl:absolute rounded-bl-md rounded-br-md border-gray-700 flex flex-col">
                                                                <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/contact-us/corporate-purchase">Corporate Purchase</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/contact-us/store-locator">Store Location</a>
                                    </div>
                    </li>
            </ul>

            </div>
            <div class="flex flex-row space-x-4">
                <!-- <a href="https://live.prodapp.baskinrobbins.my/ad/openapp.html?action=home" target="_blank" class="flex py-3 px-6 leading-4 text-center rounded-full bg-white text-[#8BC1DE] self-center">
                    Order<br/>Online
                </a> -->
                            </div>
        </div>
                <div class="xl:hidden flex flex-wrap flex-row justify-between relative" x-data="{isOpen: false }">
            <div class="toggle-container" id="toggle-btn" @click="isOpen = true">
                <span id="line-1"></span>
                <span id="line-2"></span>
                <span id="line-3"></span>
            </div>
            <div class="w-[55px] xl:w-16  xl:mx-0 flex items-center">
                <a href="/">
                    <img src="@/components/Header/images/br-logo.png" class="w-full" alt="Baskin Robbins" />
                </a>
            </div>
            <div class="flex flex-row space-x-2">
                <!-- <a href="https://live.prodapp.baskinrobbins.my/ad/openapp.html?action=home" target="_blank" class="flex py-2 px-4 leading-3 text-center rounded-full bg-white text-[#8BC1DE] font-bold text-xs items-center">
                    Order<br/>Online
                </a> -->
                            </div>
            <div class="menu" style="z-index: 2001;" id="mobile-menu" :class="{ 'open' : isOpen }">
                <div class="absolute right-[5%] top-[24px] w-8 h-8 bg-[#F4F4F4] rounded-full" id="close_menu" @click="isOpen = false">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 ml-1 mt-1">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div class="w-[140px] h-[18px] mx-auto mt-[80px] mb-[40px] relative">
                    <a href="/">
                        <img src="@/components/Header/images/br-logo-mobile-menu.png" class="w-full" alt="Baskin Robbins"/>
                    </a>
                </div>
                

            <ul class="flex flex-col space-y-5 xl:flex-row xl:space-y-0 items-start xl:h-full" >
                <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href="/"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Home
            </a>
                    </li>
            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
            @click="(isActive&&activeIndex==1)?isActive=false:isActive=true,activeIndex=1"
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                What&#039;s New
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                            <div
                    @mouseover="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = true ; isActive = true;
                    }"
                    @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = false ; isActive = false;
                    }"
                    :class="{ 'active': isActive&&activeIndex==1 }"
                    class="dropdown-list ml-4 xl:bg-white xl:ml-0 xl:top-[92px] relative xl:absolute rounded-bl-md rounded-br-md border-gray-700 flex flex-col">
                                                                <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/whats-new/happy-value-pack">Happy Value Pack</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/whats-new/variety-pack">Variety Pack</a>
                                    </div>
                    </li>

                    <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href="https://live.prodapp.baskinrobbins.my/oms/#/chooseLocation/index"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                ORDER NOW
            </a>
                    </li>
                    <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href="https://live.prodapp.baskinrobbins.my/oms/#/center/orderList"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                MY ORDER
            </a>
                    </li>

            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                @click="(isActive&&activeIndex==2)?isActive=false:isActive=true,activeIndex=2"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Products
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                            <div
                    @mouseover="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = true ; isActive = true;
                    }"
                    @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = false ; isActive = false;
                    }"
                    :class="{ 'active': isActive&&activeIndex==2 }"
                    class="dropdown-list ml-4 xl:bg-white xl:ml-0 xl:top-[92px] relative xl:absolute rounded-bl-md rounded-br-md border-gray-700 flex flex-col">
                                                                <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/icecreams">Ice Cream</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/cakes">Cakes</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/mixnshakes">Beverages</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/party-kits">Party Kits</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/merchandise">Merchandise</a>
                                    </div>
                    </li>
            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                href="https://www.baskinrobbins.com.my/club-31-exclusive"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Club 31 Exclusive
            </a>
                    </li>
            <li  
            class="flex flex-col relative w-full xl:w-auto xl:h-full" 
            x-data="{ open: false, isActive: false, hasDropdown: false }" 
            x-init="hasDropdown = !!$el.querySelector('.dropdown-list')"
        >
            <a 
                 
                class="flex flex-row xl:items-center xl:justify-center items-baseline px-3 xl:pl-3 xl:pr-12 dropdown-btn relative xl:h-full text-lg uppercase" 
                @click="(isActive&&activeIndex==4)?isActive=false:isActive=true,activeIndex=4"
                @mouseover="
                width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = true ; isActive = true;
                }"
                @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                if (width > 1280) {
                    open = false ; isActive = false;
                }"
            >
                                Contact Us
                                <i x-show="hasDropdown" class="menu-icon pointer-events-none"></i>
            </a>
                            <div
                    @mouseover="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = true ; isActive = true;
                    }"
                    @mouseout="width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
                    if (width > 1280) {
                        open = false ; isActive = false;
                    }"
                    :class="{ 'active': isActive&&activeIndex==4}"
                    class="dropdown-list ml-4 xl:bg-white xl:ml-0 xl:top-[92px] relative xl:absolute rounded-bl-md rounded-br-md border-gray-700 flex flex-col">
                                                                <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/contact-us/corporate-purchase">Corporate Purchase</a>
                                            <a class=" text-black hover:bg-[rgba(119,203,205,0.49)] hover:last:rounded-bl-md hover:last:rounded-br-md p-[10px]" href="https://www.baskinrobbins.com.my/contact-us/store-locator">Store Location</a>
                                    </div>
                    </li>
            </ul>


                <div class="flex flex-col flex-wrap relative pt-6 left-[36px]">
                    <hr class="border-t border-[#DEDEDE] w-[87%] mb-[10px] ">
                    <p class="mb-3">Follow Us</p>
                    <div class="flex space-x-[11px] basis-full">
                        <a class="relative block w-[34px] h-[34px] rounded-full bg-[#3C2222]" href="https://www.instagram.com/baskinrobbinsmalaysia/">
                            <svg viewBox="0 0 24 24" fill="none" width="25px" height="25px" class="absolute top-1 left-1 right-1 bottom-1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 7.90001C11.1891 7.90001 10.3964 8.14048 9.72218 8.59099C9.04794 9.0415 8.52243 9.68184 8.21211 10.431C7.90179 11.1802 7.8206 12.0046 7.9788 12.7999C8.13699 13.5952 8.52748 14.3258 9.10088 14.8992C9.67427 15.4725 10.4048 15.863 11.2001 16.0212C11.9955 16.1794 12.8198 16.0982 13.569 15.7879C14.3182 15.4776 14.9585 14.9521 15.409 14.2779C15.8596 13.6036 16.1 12.8109 16.1 12C16.1013 11.4612 15.9962 10.9275 15.7906 10.4295C15.585 9.93142 15.2831 9.47892 14.9021 9.09794C14.5211 8.71695 14.0686 8.415 13.5706 8.20942C13.0725 8.00385 12.5388 7.8987 12 7.90001ZM12 14.67C11.4719 14.67 10.9557 14.5134 10.5166 14.22C10.0776 13.9267 9.73534 13.5097 9.53326 13.0218C9.33117 12.5339 9.2783 11.9971 9.38132 11.4791C9.48434 10.9612 9.73863 10.4854 10.112 10.112C10.4854 9.73863 10.9612 9.48434 11.4791 9.38132C11.9971 9.2783 12.5339 9.33117 13.0218 9.53326C13.5097 9.73534 13.9267 10.0776 14.22 10.5166C14.5134 10.9557 14.67 11.4719 14.67 12C14.67 12.7081 14.3887 13.3873 13.888 13.888C13.3873 14.3887 12.7081 14.67 12 14.67ZM17.23 7.73001C17.23 7.9278 17.1714 8.12114 17.0615 8.28558C16.9516 8.45003 16.7954 8.57821 16.6127 8.65389C16.43 8.72958 16.2289 8.74938 16.0349 8.7108C15.8409 8.67221 15.6628 8.57697 15.5229 8.43712C15.3831 8.29727 15.2878 8.11909 15.2492 7.92511C15.2106 7.73112 15.2304 7.53006 15.3061 7.34733C15.3818 7.16461 15.51 7.00843 15.6744 6.89855C15.8389 6.78866 16.0322 6.73001 16.23 6.73001C16.4952 6.73001 16.7496 6.83537 16.9371 7.02291C17.1247 7.21044 17.23 7.4648 17.23 7.73001ZM19.94 8.73001C19.9691 7.48684 19.5054 6.28261 18.65 5.38001C17.7522 4.5137 16.5474 4.03897 15.3 4.06001C14 4.00001 10 4.00001 8.70001 4.06001C7.45722 4.0331 6.25379 4.49652 5.35001 5.35001C4.49465 6.25261 4.03093 7.45684 4.06001 8.70001C4.00001 10 4.00001 14 4.06001 15.3C4.03093 16.5432 4.49465 17.7474 5.35001 18.65C6.25379 19.5035 7.45722 19.9669 8.70001 19.94C10.02 20.02 13.98 20.02 15.3 19.94C16.5432 19.9691 17.7474 19.5054 18.65 18.65C19.5054 17.7474 19.9691 16.5432 19.94 15.3C20 14 20 10 19.94 8.70001V8.73001ZM18.24 16.73C18.1042 17.074 17.8993 17.3863 17.6378 17.6478C17.3763 17.9093 17.064 18.1142 16.72 18.25C15.1676 18.5639 13.5806 18.6715 12 18.57C10.4228 18.6716 8.83902 18.564 7.29001 18.25C6.94608 18.1142 6.63369 17.9093 6.37223 17.6478C6.11076 17.3863 5.90579 17.074 5.77001 16.73C5.35001 15.67 5.44001 13.17 5.44001 12.01C5.44001 10.85 5.35001 8.34001 5.77001 7.29001C5.90196 6.94268 6.10547 6.62698 6.36733 6.36339C6.62919 6.09981 6.94355 5.89423 7.29001 5.76001C8.83902 5.44599 10.4228 5.33839 12 5.44001C13.5806 5.33856 15.1676 5.44616 16.72 5.76001C17.064 5.89579 17.3763 6.10076 17.6378 6.36223C17.8993 6.62369 18.1042 6.93608 18.24 7.28001C18.66 8.34001 18.56 10.84 18.56 12C18.56 13.16 18.66 15.67 18.24 16.72V16.73Z" fill="#ffffff"></path> </g></svg>
                        </a>
                        <a class="relative block w-[34px] h-[34px] rounded-full bg-[#3C2222]" href="https://www.facebook.com/MYBaskinRobbins/">
                            <svg width="18px" height="20px" class="absolute top-[6px] left-2 right-2 bottom-[6px]" viewBox="-5 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>facebook [#176]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-385.000000, -7399.000000)" fill="#ffffff"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M335.821282,7259 L335.821282,7250 L338.553693,7250 L339,7246 L335.821282,7246 L335.821282,7244.052 C335.821282,7243.022 335.847593,7242 337.286884,7242 L338.744689,7242 L338.744689,7239.14 C338.744689,7239.097 337.492497,7239 336.225687,7239 C333.580004,7239 331.923407,7240.657 331.923407,7243.7 L331.923407,7246 L329,7246 L329,7250 L331.923407,7250 L331.923407,7259 L335.821282,7259 Z" id="facebook-[#176]"> </path> </g> </g> </g> </g></svg>
                        </a>
                        <a class="relative block w-[34px] h-[34px] rounded-full bg-[#3C2222]" href="https://www.youtube.com/channel/UCLndlH6UNEsNJVCpl9usf5w">
                            <svg width="19px" height="25px" class="absolute top-1 left-2 right-1 bottom-1" viewBox="0 -3 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>youtube [#168]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-300.000000, -7442.000000)" fill="#ffffff"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M251.988432,7291.58588 L251.988432,7285.97425 C253.980638,7286.91168 255.523602,7287.8172 257.348463,7288.79353 C255.843351,7289.62824 253.980638,7290.56468 251.988432,7291.58588 M263.090998,7283.18289 C262.747343,7282.73013 262.161634,7282.37809 261.538073,7282.26141 C259.705243,7281.91336 248.270974,7281.91237 246.439141,7282.26141 C245.939097,7282.35515 245.493839,7282.58153 245.111335,7282.93357 C243.49964,7284.42947 244.004664,7292.45151 244.393145,7293.75096 C244.556505,7294.31342 244.767679,7294.71931 245.033639,7294.98558 C245.376298,7295.33761 245.845463,7295.57995 246.384355,7295.68865 C247.893451,7296.0008 255.668037,7296.17532 261.506198,7295.73552 C262.044094,7295.64178 262.520231,7295.39147 262.895762,7295.02447 C264.385932,7293.53455 264.28433,7285.06174 263.090998,7283.18289" id="youtube-[#168]"> </path> </g> </g> </g> </g></svg>
                        </a>
                        <a class="relative block w-[34px] h-[34px] rounded-full bg-[#3C2222]" href="https://www.tiktok.com/@baskinrobbinsmalaysia">
                            <svg width="20px" height="25px" class="absolute top-1 left-2 right-1 bottom-1" fill="#ffffff" viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m 4.9520184,12.936803 c -1.12784,-0.2039 -2.19411,-0.9875 -2.66789,-1.9606 -0.32895,-0.6757 -0.45541,-1.3901003 -0.37418,-2.1137003 0.15054,-1.3412 0.84482,-2.4395 1.92406,-3.0439 0.56899,-0.3186 1.38421,-0.4769 1.991,-0.3867 l 0.35091,0.052 9e-5,1.0725 9e-5,1.0725 -0.332,-0.014 c -0.79998,-0.033 -1.39595,0.3096 -1.70379,0.9784 -0.1473,0.32 -0.18461,0.8887 -0.081,1.2351 0.12773,0.4273003 0.50542,0.8132003 0.96145,0.9825003 0.15535,0.058 0.32344,0.08 0.61152,0.079 0.35862,-4e-4 0.42448,-0.013 0.67663,-0.1323 0.36505,-0.1726 0.63141,-0.4231 0.78797,-0.7411 0.10147,-0.2061003 0.13414,-0.3430003 0.16587,-0.6951003 0.0217,-0.2412 0.0401,-2.2122 0.0409,-4.38 l 10e-4,-3.94149998 0.68371,0 c 0.37605,0 0.8277,0.012 1.00368,0.027 l 0.31995,0.027 0,0.1584 c 0,0.3813 0.22299,1.1127 0.45156,1.4812 0.0571,0.092 0.2564996,0.3178 0.4431796,0.5018 0.36068,0.3555 0.66494,0.5352 1.13352,0.6692 0.138,0.04 0.28359,0.089 0.32353,0.109 0.0399,0.02 0.11522,0.038 0.16728,0.038 0.0521,4e-4 0.13701,0.012 0.18876,0.026 l 0.0941,0.025 0,0.9948 0,0.9948 -0.17773,-0.019 c -0.9611,-0.1037 -1.72925,-0.3601 -2.3423096,-0.782 -0.30468,-0.2096 -0.33102,-0.222 -0.30218,-0.1422 0.0104,0.029 0.003,1.1249 -0.0164,2.436 -0.0336,2.2728 -0.0396,2.3992 -0.12781,2.7173003 -0.33904,1.2222 -1.09994,2.1297 -2.10183,2.5068 -0.6126,0.2306 -1.39679,0.2932 -2.09405,0.1671 z"></path></g></svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
    
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
    
  },
  data(){
    return{
        window:window,
        hasDropdown:false,
      mobileTitleBoolean:false,
      isActive:false,
      isOpen:false,
      activeIndex:0

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./header.css'></style>
